export class CustomProduct {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    name= '',
                    reference= '',
                    sku= '',
                    ean= '',
                    combo_id= null,
                    classes_group_id= null,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    product= null,
                    classes_group= null,
                    classes= []
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.name=name;
        this.reference=reference;
        this.sku=sku;
        this.ean=ean;
        this.combo_id= combo_id;
        this.classes_group_id=classes_group_id;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.product = product;
        this.classes_group = classes_group;
        this.classes = classes;
    }

}

export function createCustomProduct(data={}) {
    return Object.freeze(new CustomProduct(data));
}